export const API_URL = {
    'employee.all': 'pms/employee',
    'employee.create': 'pms/employee/create',
    'employee.edit': 'pms/employee/edit/:id',
    'employee.delete': 'pms/employee/delete/:id',
    'employee.change': 'pms/employee/change/:id',
    'employee.editPass': 'pms/employee/editPassword',
}
